document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-course-product]').forEach((root) => {
    const json = root.querySelector('[data-variants-json]');
    if (!json) return;
    let data;
    try {
      data = JSON.parse(json.textContent);
    } catch (error) {
      console.error('Ekki tókst að lesa námslotur.', error);
      return;
    }
    const id = root.querySelector('[data-variant-id]');
    const courseId = root.querySelector('[data-course-id]');
    const prices = root.querySelectorAll('[data-price]');
    const startDates = root.querySelectorAll('[data-start-date]');
    const button = root.querySelector('[data-buy-button]');
    if (!id || !courseId || !button) return;

    const enrollButtons = root.querySelectorAll('[data-enroll-button]');
    const updateEnrollButtons = (variant) => {
      const ready = variant.available && Boolean(variant.courseId);
      enrollButtons.forEach((control) => {
        control.disabled = !ready;
        control.textContent = !variant.available
          ? 'Uppselt'
          : ready ? control.dataset.readyLabel : 'Skráning tímabundið óvirk';
      });
    };
    enrollButtons.forEach((control) => {
      control.addEventListener('click', () => {
        if (control.disabled) return;
        root.querySelector('#AkademiasCourseForm')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        button.focus({ preventScroll: true });
      });
    });
    const initialVariant = data.find((item) => String(item.id) === id.value);
    if (initialVariant) updateEnrollButtons(initialVariant);

    root.querySelectorAll('input[name="cohort"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const variant = data.find((item) => String(item.id) === radio.value);
        if (!variant) return;
        id.value = variant.id;
        courseId.value = variant.courseId || '';
        prices.forEach((price) => { price.textContent = variant.price; });
        startDates.forEach((startDate) => {
          startDate.textContent = variant.startLabel
            ? `Næsta lota hefst ${variant.startLabel}.`
            : startDate.dataset.emptyText;
        });
        const canBuy = variant.available && Boolean(variant.courseId);
        button.disabled = !canBuy;
        updateEnrollButtons(variant);
        button.textContent = !variant.available
          ? 'Uppselt'
          : variant.courseId
            ? button.dataset.readyLabel || 'Tryggja mér sæti'
            : 'Skráning tímabundið óvirk';
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      });
    });

    const form = root.querySelector('#AkademiasCourseForm');
    if (form) {
      form.addEventListener('submit', () => {
        if (button.disabled) return;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Bæti í körfu…';
      });
    }
  });

  document.querySelectorAll('.mobile-menu').forEach((menu) => {
    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => { menu.open = false; });
    });
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        menu.open = false;
        menu.querySelector('summary')?.focus();
      }
    });
  });

  document.querySelectorAll('[data-expert-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-expert-track]');
    const previous = carousel.querySelector('[data-expert-prev]');
    const next = carousel.querySelector('[data-expert-next]');
    const controls = carousel.querySelector('.carousel-controls');
    if (!track || !previous || !next || !controls) return;

    const step = () => {
      const card = track.querySelector('.course-expert-card');
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    };
    const update = () => {
      const overflow = track.scrollWidth > track.clientWidth + 2;
      controls.hidden = !overflow;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    previous.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') track.scrollBy({ left: -step(), behavior: 'smooth' });
      if (event.key === 'ArrowRight') track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    window.addEventListener('resize', update, { passive: true });
    update();
  });

});
